// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#header {
    /* position: absolute; */
    position: fixed;
    width: 250px;
}

#header .pro-sidebar {
height: 100vh;
}

#header .closemenu {
color: white;
position: absolute;
right: 0;
z-index: 9999;
line-height: 20px;
border-radius: 50%;
font-weight: bold;
font-size: 22px;
top: 45px;
cursor: pointer;
}

#header .pro-sidebar {
width: 100%;
min-width: 100%;
}

#header .pro-sidebar.collapsed {
width: 80px;
min-width: 80px;
}

#header .pro-sidebar-inner {
/* background-color: #2a2a2a; */
background-color: #12344d;
box-shadow: 0.5px 0.866px 2px 0px rgba(0, 0, 0, 0.15);
}

#header .pro-sidebar-inner .pro-sidebar-layout {
overflow-y: hidden;
}

#header .pro-sidebar-inner .pro-sidebar-layout .logotext p {
font-size: 20px;
padding: 10px 10px 0px 15px;
color: #000;
font-weight: bold;
}

#header .pro-sidebar-inner .pro-sidebar-layout ul {
padding: 0 5px;
}

#header .pro-sidebar-inner .pro-sidebar-layout ul .pro-inner-item {
color: white;
margin: 10px 0px;
font-weight: bold;
}

#header .pro-sidebar-inner .pro-sidebar-layout ul .pro-inner-item .pro-icon-wrapper {
background-color: white;
color: #000;
border-radius: 3px;
}

#header .pro-sidebar-inner .pro-sidebar-layout ul .pro-inner-item .pro-icon-wrapper .pro-item-content {
color: #000;
}

#header .pro-sidebar-inner .pro-sidebar-layout .active {
background-image: linear-gradient(0deg, rgba(52, 92, 124, 1)/*rgba(0, 76, 102, 1)*//*rgba(41, 241, 195, 1)*/ 0%, rgba(52, 92, 124, 1)/*rgba(0, 76, 102, 1)*//*rgba(41, 241, 195, 1)*/ 100%);
border-radius: 5px;
}

#header .logo {
padding: 20px;
}

#selectedItem {
color: black !important;
}

@media only screen and (max-width: 720px) {
    html {
    overflow: hidden;
    }
}

@media only screen and (max-width: 775px) {

    .closedSidebarMenu {
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/Sidebar.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,eAAe;IACf,YAAY;AAChB;;AAEA;AACA,aAAa;AACb;;AAEA;AACA,YAAY;AACZ,kBAAkB;AAClB,QAAQ;AACR,aAAa;AACb,iBAAiB;AACjB,kBAAkB;AAClB,iBAAiB;AACjB,eAAe;AACf,SAAS;AACT,eAAe;AACf;;AAEA;AACA,WAAW;AACX,eAAe;AACf;;AAEA;AACA,WAAW;AACX,eAAe;AACf;;AAEA;AACA,+BAA+B;AAC/B,yBAAyB;AACzB,qDAAqD;AACrD;;AAEA;AACA,kBAAkB;AAClB;;AAEA;AACA,eAAe;AACf,2BAA2B;AAC3B,WAAW;AACX,iBAAiB;AACjB;;AAEA;AACA,cAAc;AACd;;AAEA;AACA,YAAY;AACZ,gBAAgB;AAChB,iBAAiB;AACjB;;AAEA;AACA,uBAAuB;AACvB,WAAW;AACX,kBAAkB;AAClB;;AAEA;AACA,WAAW;AACX;;AAEA;AACA,2LAA2L;AAC3L,kBAAkB;AAClB;;AAEA;AACA,aAAa;AACb;;AAEA;AACA,uBAAuB;AACvB;;AAEA;IACI;IACA,gBAAgB;IAChB;AACJ;;AAEA;;IAEI;QACI,aAAa;IACjB;AACJ","sourcesContent":["#header {\n    /* position: absolute; */\n    position: fixed;\n    width: 250px;\n}\n\n#header .pro-sidebar {\nheight: 100vh;\n}\n\n#header .closemenu {\ncolor: white;\nposition: absolute;\nright: 0;\nz-index: 9999;\nline-height: 20px;\nborder-radius: 50%;\nfont-weight: bold;\nfont-size: 22px;\ntop: 45px;\ncursor: pointer;\n}\n\n#header .pro-sidebar {\nwidth: 100%;\nmin-width: 100%;\n}\n\n#header .pro-sidebar.collapsed {\nwidth: 80px;\nmin-width: 80px;\n}\n\n#header .pro-sidebar-inner {\n/* background-color: #2a2a2a; */\nbackground-color: #12344d;\nbox-shadow: 0.5px 0.866px 2px 0px rgba(0, 0, 0, 0.15);\n}\n\n#header .pro-sidebar-inner .pro-sidebar-layout {\noverflow-y: hidden;\n}\n\n#header .pro-sidebar-inner .pro-sidebar-layout .logotext p {\nfont-size: 20px;\npadding: 10px 10px 0px 15px;\ncolor: #000;\nfont-weight: bold;\n}\n\n#header .pro-sidebar-inner .pro-sidebar-layout ul {\npadding: 0 5px;\n}\n\n#header .pro-sidebar-inner .pro-sidebar-layout ul .pro-inner-item {\ncolor: white;\nmargin: 10px 0px;\nfont-weight: bold;\n}\n\n#header .pro-sidebar-inner .pro-sidebar-layout ul .pro-inner-item .pro-icon-wrapper {\nbackground-color: white;\ncolor: #000;\nborder-radius: 3px;\n}\n\n#header .pro-sidebar-inner .pro-sidebar-layout ul .pro-inner-item .pro-icon-wrapper .pro-item-content {\ncolor: #000;\n}\n\n#header .pro-sidebar-inner .pro-sidebar-layout .active {\nbackground-image: linear-gradient(0deg, rgba(52, 92, 124, 1)/*rgba(0, 76, 102, 1)*//*rgba(41, 241, 195, 1)*/ 0%, rgba(52, 92, 124, 1)/*rgba(0, 76, 102, 1)*//*rgba(41, 241, 195, 1)*/ 100%);\nborder-radius: 5px;\n}\n\n#header .logo {\npadding: 20px;\n}\n\n#selectedItem {\ncolor: black !important;\n}\n\n@media only screen and (max-width: 720px) {\n    html {\n    overflow: hidden;\n    }\n}\n\n@media only screen and (max-width: 775px) {\n\n    .closedSidebarMenu {\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
